import Breadcrumb from "../Component/Breadcrumb";
const AimObj = () => {
  return (
    <>
      <Breadcrumb
        breadtitle="Aims & Objective"
        breadmid="About"
        breadend="Aims & Objective"
      />
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <img
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/dart.jpg"
                className="img-fluid"
              ></img>
            </div>
            <div className="col-md-6">
              <h2 className="maintitle">Aims & Objective</h2>
              <h4>
                The Primary aim of Canosa School is to impart sound formation
                (spiritual, mental, moral, social and physical) based on the
                principles of Christian faith, to the members of the Christian
                Community. It also imparts a sound formation - spiritual,
                mental, moral, social and physical, to all other admitted to
                this Institution without distinction. Co-curowicular activities
                of a varied nature are provided in order to promote a harmonius
                development of both mind and body. The School encourages the
                stdents to participate in various activities inorder to
                facilitate the development of their potentialities...
              </h4>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default AimObj;
